/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {assert} from 'chai';

import GrantAccessMutation from './GrantAccessMutation.react';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import {LoadingLine} from '../loadingLine/renderLoadingPanel.react';
import MiniLogo from '../app/MiniLogo.react';
import mutationError from '../channel-defs/mutationError';
import TestChannelAuthMutation from "./TestChannelAuthMutation.react";
import {safeJSONparse} from "../../common/util/safeJSONparse";
import {getQueryParams} from '../../common/util/QueryParams';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'channelGranted.title', 'defaultMessage': 'Application access granted'}
});

function hexToString(str1) {
    let hex  = str1.toString();
    let trimString = hex.trim();

    // in case the string is not in hexa
    if (trimString.startsWith('{') || trimString.startsWith('[')) {
        return trimString;
    }

    let str = '';
    for (let n = 0; n < hex.length; n += 2) {
        str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
    }
    return str;
}

export function ChannelGrantedOnMount(relay) {
    return new Promise(function(resolve, reject) {
        /* extract 'state' from URL - it is the only variable allowed by OAuth */
        let args = getQueryParams(document.location.search);

        let state = safeJSONparse(hexToString(args['state'] || ''));

        relay.commitUpdate(
            new GrantAccessMutation({
                args: JSON.stringify({
                    url: document.location.href,
                    ...state,
                }),
                params: JSON.stringify(args),
                ...state,
            }), {onSuccess: resolve, onFailure: reject}
        );
    });
}

export function testChannelAuth(channel, relay) {
    return new Promise(function(resolve, reject) {
        let metadata = safeJSONparse(hexToString(channel.channelDef.metadata));
        if (metadata.hasAuthTest) {
            relay.commitUpdate(
                new TestChannelAuthMutation({
                    'channel': channel
                }), {onSuccess: resolve, onFailure: reject}
            );
        } else {
            //this._authTestDone(channel);
            resolve();
        }
    });
}

interface ChannelGrantedProps {
 intl: IntlShape;
 relay?: object;
 user: User;
}

class ChannelGranted extends React.Component<ChannelGrantedProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired,
    };

    typeName = 'channels';

    static contextTypes = {
        router: PropTypes.object,
    };

    constructor(props) {
        super(props);

        let queryParams = getQueryParams(window.location.search || '');

        this.state = {
            error: !!(queryParams && queryParams.error) || false
        };
    }

    componentDidMount() {
        if (!this.state.error) {
            ChannelGrantedOnMount(this.props.relay).then((response) => {
                if (response.grantAccess && response.grantAccess.result && response.grantAccess.result !== 'ok') {
                    this.setState({
                        "error": true,
                        "errorText": response.grantAccess.result,
                    });
                    return;
                }
                let channel = response.grantAccess.channel;
                if (response.grantAccess.redirectUrl) {
                    window.location = response.grantAccess.redirectUrl;
                    return;
                }

                return testChannelAuth(channel, this.props.relay).then(() => {
                    this.context.router.push(response.grantAccess.url); // redirect
                });
            }, mutationError).catch((e) => {
                throw new Error(e);
            });
        }
    }

    render() {
        if (this.state.error) {
            return (
                <AppPanel title={this.props.intl.formatMessage(messages.title)}>
                    <center>
                        {this.state.errorText ?
                            <div>
                                <h4><FormattedMessage defaultMessage="Something went wrong during grant access: " id="channelGranted.grantAccessError2" /></h4>
                                <small><code>{this.state.errorText}</code></small>
                            </div>

                            :
                            <h4><FormattedMessage defaultMessage="Something went wrong during grant access, please start again." id="channelGranted.grantAccessError" /></h4>
                        }
                    </center>
                </AppPanel>
            );
        }

        return (
            <AppPanel title={this.props.intl.formatMessage(messages.title)}>
                <center>
                    <LoadingLine />
                    <MiniLogo color width="150px"/>
                    <p><strong><FormattedMessage defaultMessage="Redirecting…" id="channelGranted.working" /></strong></p>
                </center>
            </AppPanel>
        );
    }
}


export default Relay.createContainer(injectIntl(ChannelGranted), {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                id
            }
        `,
    },
});

// eslint-disable-next-line max-params
export function callGrant(channel, scenario, type, relay) {
    assert.isDefined(relay);

    return new Promise((resolve, reject) => {
        let onSuccess = (response) => {
            window.location = response.grantAccess.url;

            // never release promise. Otherwise it will finish to user before the redirect
            //deferred.resolve();
        };
        let onFailure = (transaction) => {
            mutationError(transaction);

            reject();
        };

        let args = {
            'type': type,
            'operation': 'grant',
            'channel_id': channel['realId'],
            'organisation_id':  channel['organisation_id']
        };

        if (scenario) {
            args['scenario_id'] = scenario['realId'];
        }

        relay.commitUpdate(
            new GrantAccessMutation(args), {onSuccess: onSuccess, onFailure: onFailure}
        );
    });
}
